/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { INavigationMenuViewProps } from '@msdyn365-commerce-modules/navigation-menu';
import * as React from 'react';

import { INavigationMenuProps } from '../definition-extensions/navigation-menu.ext.props.autogenerated';
import NavigationMenuRootDisabled from './components/navigation-menu-root-disabled';
import NavigationMenuRootEnabled from './components/navigation-menu-root-enabled';

/**
 * Render the Navigation menu.
 * @param props - The navigation menu view props.
 * @returns Return HTML having INavigationMenuViewProps props with navigation menu.
 */
const navigationMenuView = (props: INavigationMenuViewProps & INavigationMenuProps<{}>): JSX.Element => {

    if (props.config.enabletopMenu) {
        return <NavigationMenuRootEnabled navProps={props} />;
    }

    return <NavigationMenuRootDisabled navProps={props} />;

};

export default navigationMenuView;
